import {
  Component,
  ViewEncapsulation,
  Inject,
  PLATFORM_ID,
} from "@angular/core";
import { environment } from "src/environments/environment";
import { CheckForUpdate } from "./core/services/check-for-update.service";
import { LogUpdate } from "./core/services/log-update.service";
import { PromptUpdate } from "./core/services/prompt-update.service";
import { Seo } from "./core/services/seo.service";

@Component({
  selector: "common-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.sass"],
  encapsulation: ViewEncapsulation.None,
})
export class AppComponent {
  environment = environment;

  constructor(
    private checkForUpdate: CheckForUpdate,
    private logUpdate: LogUpdate,
    private seo: Seo,
    private promptUpdateService: PromptUpdate,
    @Inject(PLATFORM_ID) public platformId: object,
  ) {
    this.seo.setTitle(environment.title);
    this.seo.setDescription(environment.description);
    this.seo.setCanonicalURL("/");
  }
}
